function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaretDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "187.898 142.128 136.636 84.373",
    width: 136.636,
    height: 84.373,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M 203.953 226.501 L 256.216 174.351 L 308.479 226.501 L 324.534 210.446 L 256.216 142.128 L 187.898 210.446 L 203.953 226.501 Z",
    style: {
      transformOrigin: "256.216px 184.315px"
    },
    transform: "matrix(-1, 0, 0, -1, 0, 0)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDown);
export default __webpack_public_path__ + "static/media/caret-down.bff20ba9.svg";
export { ForwardRef as ReactComponent };